import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import dayjs from "dayjs"
import { BillRequest } from "./billRequest"
import {
  BillRequestStatus,
  BillRequestTypeCode,
  IBillRequest,
} from "./billRequest.types"
import { BillRequest as BillRequestDto } from "@/api/backofficeRest/generated/model"

export type IBillRequestRaw = BillRequestDto

export const BillRequestParser: IParser<IBillRequest, IBillRequestRaw> = {
  toDomain: (data: IBillRequestRaw) => {
    try {
      return new BillRequest(
        Number(data.id),
        Number(data.billId),
        dayjs(data.billPeriodFromDttm),
        dayjs(data.billPeriodToDttm),
        data.statusCode as BillRequestStatus,
        dayjs(data.taskCreatedDttm),
        dayjs(data.taskFinishDttm),
        dayjs(data.taskStartDttm),
        data.taskUserTblUsername,
        data.typeCode as BillRequestTypeCode,
        data.testFl,
        data.serverExceptionMessage ?? undefined,
        // Guard on null rather than reusing the Number() pattern above:
        // coreBillId is nullable and Number(null) is 0, not NaN, which would
        // make an unmapped bill request false-match transaction.billId.
        data.coreBillId != null ? Number(data.coreBillId) : undefined,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
